// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M14.9999 12L9.49988 6.5L9.49988 17.5L14.9999 12Z"}}]};

const CaretRightSmallIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-right-small',
    ref,
    icon: element,
  },
));

CaretRightSmallIcon.displayName = 'CaretRightSmallIcon';

export default CaretRightSmallIcon;
